import {EventEmitter, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {WasteZone} from "../model/waste-zone.model";
import {map} from "rxjs/operators";
import * as moment from "moment/moment";
import * as _ from "lodash";

@Injectable({
  providedIn: 'root'
})
export class WasteService {

  private _baseUrl: string = environment.host + "/waste";
  private _userZone: string;
  private USER_ZONE_KEY_LS: string = 'userZone';

  changeWasteZone = new EventEmitter();

  constructor(private httpClient: HttpClient) {
    this._userZone = localStorage.getItem(this.USER_ZONE_KEY_LS);
  }

  public searchWasteZoneList(zona: string): Observable<WasteZone[]> {
    return this.httpClient.get<WasteZone[]>(this._baseUrl + "/calendar", {
      params: {
        zona
      }
    });
  }

  get userZone() {
    return this._userZone || '-1';
  }

  get hasUserZone() {
    return this._userZone && this._userZone != '-1';
  }

  set userZone(zone: string) {

    this._userZone = zone;
    localStorage.setItem(this.USER_ZONE_KEY_LS, zone);
    this.changeWasteZone.emit(this._userZone);
  }

  getDailyUserWasteZone() {
    return this.searchWasteZoneList(this._userZone).pipe(map(res => {
      const filtered = _.filter(res, item => moment().isAfter() || item.weekDayNumber == WasteService.calculateWeekDayNumber().weekday());
      return filtered;
    }))
  }

  static calculateWeekDayNumber(today: moment.Moment = moment()) {

    const day = today.isBefore(today.clone().set({hours: 8, minutes: 0})) ? today : today.clone().add(1, 'days');

    return day;
  }

}
